import { lazy } from "react";

// project-imports
import Loadable from "components/Loadable";

/**
 * Lazy-loaded component for rendering the list of EmailTemplates.
 * @constant {LazyExoticComponent<React.ComponentType<any>>} ListEmailTemplatePage - Lazy-loaded ListEmailTemplatePage component.
 */
const ListEmailTemplatePage = Loadable(
  lazy(() => import("./ListEmailTemplatePage"))
);

/**
 * Lazy-loaded component for rendering the add EmailTemplate page.
 * @constant {LazyExoticComponent<React.ComponentType<any>>} AddEmailTemplatePage - Lazy-loaded AddEmailTemplatePage component.
 */
const AddEmailTemplatePage = Loadable(
  lazy(() => import("./AddEmailTemplatePage"))
);

/**
 * Lazy-loaded component for rendering the View EmailTemplate page.
 * @constant {LazyExoticComponent<React.ComponentType<any>>} EditEmailTemplatePage - Lazy-loaded EditEmailTemplatePage component.
 */
const EditEmailTemplatePage = Loadable(
  lazy(() => import("./EditEmailTemplatePage"))
);

/**
 * Array containing route definitions for the EmailTemplate-related pages.
 * @constant {Object[]} EmailTemplateRoutes - Array of EmailTemplate route objects.
 * @property {string} EmailTemplateRoutes[].path - The EmailTemplate of the EmailTemplate route.
 * @property {React.ReactElement} EmailTemplateRoutes[].element - The React element to be rendered for the EmailTemplate route.
 */
const EmailTemplateRoutes = [
  {
    path: "list",
    element: <ListEmailTemplatePage />,
  },
  {
    path: "add",
    element: <AddEmailTemplatePage />,
  },
  {
    path: "edit/:email_template_id",
    element: <EditEmailTemplatePage />,
  },
];

export default EmailTemplateRoutes;
